import { EventNamesList, trackSegmentAndGAEvent } from '@zoopla/tracking';

type TrackingData = {
    eventName: EventNamesList;
    eventAction: string;
    eventLabel: string;
    path: string;
};

const PROPERTY_PATH_PREFIX = '/property/uprn/';
const MY_HOME_PATH_PREFIX = '/myaccount/my-home/uprn/';

export const trackingHandler = ({
    eventName,
    eventAction,
    eventLabel,
    path,
}: TrackingData) => {
    if (
        path.includes(PROPERTY_PATH_PREFIX) ||
        path.includes(MY_HOME_PATH_PREFIX)
    ) {
        const eventCategory = path.includes(PROPERTY_PATH_PREFIX)
            ? 'property details'
            : 'my home estimate';

        trackSegmentAndGAEvent(
            eventName,
            {
                eventCategory,
                eventAction,
                eventLabel,
            },
            path.split('?')[0]
        );
    }
};
